import { Component, OnInit } from '@angular/core';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';

@Component({
  selector: 'app-recadastramento',
  templateUrl: './recadastramento.component.html',
  styleUrls: ['./recadastramento.component.scss'],
})
export class RecadastramentoComponent implements OnInit {
  private readonly recurso: string = 'recadastramento'; //mesmo que a rota

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private env: EnvService
  ) {}

  ngOnInit(): void {
    if (this.env.servidor) {
      this.listar();
    } else {
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
  }
}
